import classnames from 'classnames'
import MarkerRateCounter from 'map/components/markers/MarkerRateCounter'
import styles from './styles.module.scss'

const StartFromPrice = ({
    rate,
    linkUrl,
    opngo,
    canBuy,
    addSpacing,
    isLabelTextBold,
    showAdditionalText,
    className,
}) => (
    <div className={classnames(styles.startingFromPrice, addSpacing ? 'pt-2' : '', className)}>
        <div>
            <span className={isLabelTextBold ? 'font-weight-bold' : ''}>
                <T>map.results.list.starting.from.price</T>
            </span>
            <span className="font-weight-bold">{<MarkerRateCounter opngo={opngo} canBuy={canBuy} rate={rate} />}</span>
        </div>
        <Link to={linkUrl} className={classnames(styles.viewRatesLink, addSpacing ? 'ml-3' : '')}>
            <T>map.results.list.view.rates.link</T>
        </Link>
        {showAdditionalText && (
            <span className={classnames('text-small', 'text-light', 'ml-2', 'text-right')}>
                <T>map.results.list.additional.text</T>
            </span>
        )}
    </div>
)

export default StartFromPrice
